export default "__VITE_ASSET__CL5T5Whd__"